import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import commonModule from './modules/common'
import comebackModule from './modules/comeback'
import subscriptionModule from './modules/subscription/index'
import contractModule from './modules/contract/index'
import consumptionModule from './modules/consumption/index'
import offerModule from './modules/offer/index'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  supportCircular: true,
})

export default new Vuex.Store({
  modules: {
    common: commonModule,
    contract: contractModule,
    consumption: consumptionModule,
    comeback: comebackModule,
    subscription: subscriptionModule,
    offer: offerModule
  },
  plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js